import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateRegistroAtendimentoColumnDefinition
 */

type Props = {
  onActionEditar: (idAssistenciaAtendimento: number, openModal: boolean) => void;
  onActionDelete: (idAssistenciaAtendimento: number, openModal: boolean) => void;
};

export const GenerateRegistroAtendimentoColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Reparo";
      case 0:
        return "Vistoria";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "red";
      case 0:
        return "light-blue";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Reparo";
      case 0:
        return "Vistoria";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 90,
      width: 90,
      maxWidth: 90,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição da Atividade",
      flex: 1,
      minWidth: 80,
      width: 140,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) =>
        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}> {value || ""}</span>
    },
    {
      field: "nomeFuncionario",
      filterable: false,
      headerName: "Responsável Construtora",
      flex: 1,
      minWidth: 80,
      width: 140,
      sortable: false,
      align: 'left',
    },
    {
      field: "dataInicio",
      filterable: false,
      headerName: "Data Início",
      width: 100,
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => <span>{value ? dayjs.utc(value).local().format("DD/MM/YYYY") : ""}</span>
    },
    {
      field: "dataTermino",
      filterable: false,
      headerName: "Data Término",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => <span>{value ? dayjs.utc(value).local().format("DD/MM/YYYY") : ""}</span>
    },
    {
      field: "observacoes",
      filterable: false,
      headerName: "Observações",
      flex: 1,
      width: 160,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) =>
        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}> {value || ""}</span>
    },
    {
      field: 'idAssistenciaAtendimento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={e => { onActionEditar(value, true); }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton
              onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}